export const getProviderIdFromUrl = (url: any) => {
  if(url){
    const array = url.split("/");
  const id = array[array.length - 1];
  return id;
  }
}